import styled from 'styled-components'

export const CardWrapper = styled.div`
  margin-bottom: 16px;
`
